/*
	1R Scripts Entry
*/
console.log('Initializing javascript...');

import Router from 'App/router';

/*
	Kick off FE Routing
*/
new Router();
console.log('ORW Index JS loaded CHANGED');
